// Token utility functions for debugging and cleaning localStorage

export const clearCorruptedTokens = () => {
  console.log('Clearing all supplier tokens from localStorage');
  
  // Check current token state
  const token = localStorage.getItem('supplier_token');
  console.log('Current token:', token);
  console.log('Token type:', typeof token);
  
  // Clear the token
  localStorage.removeItem('supplier_token');
  
  // Verify it's cleared
  const afterClear = localStorage.getItem('supplier_token');
  console.log('After clear:', afterClear);
  
  return { success: true, previousToken: token };
};

export const validateToken = (token) => {
  if (!token) return false;
  if (token === 'null' || token === 'undefined') return false;
  if (typeof token !== 'string') return false;
  if (token.trim() === '') return false;
  
  return true;
};

export const debugLocalStorage = () => {
  console.log('=== localStorage Debug ===');
  console.log('Length:', localStorage.length);
  
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    const value = localStorage.getItem(key);
    console.log(`${key}:`, value, `(${typeof value})`);
  }
  
  // Specific supplier token check
  const supplierToken = localStorage.getItem('supplier_token');
  console.log('=== Supplier Token Specific ===');
  console.log('Value:', supplierToken);
  console.log('Type:', typeof supplierToken);
  console.log('Length:', supplierToken ? supplierToken.length : 0);
  console.log('Is valid:', validateToken(supplierToken));
};
